import { render, staticRenderFns } from "./otelfiyatkodu.vue?vue&type=template&id=24619ae2&"
import script from "./otelfiyatkodu.vue?vue&type=script&lang=js&"
export * from "./otelfiyatkodu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports